// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f56fbfa7186e2ace7e16","532":"54db4e6bb5871b4d3712","691":"364fda368a7e20f61bde"}[chunkId] + ".js";
};